import { Grid, Typography } from '@mui/material';

import { FormAutocompleteField, FormDateField, FormTextField } from '../../../../../common';
import { US_STATE_OPTIONS } from '../../../../../../constants';
import { MEDICAL_SEVERITY_OPTIONS } from '../constants';
import { MEDICAL_STATIC_DIAGNOSIS_SX } from './styles';

import type { MedicalFieldsProps } from '../types';

export default function AsdDiagnosisFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={3} sx={MEDICAL_STATIC_DIAGNOSIS_SX}>
        <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
          Autism spectrum disorder (F84.0)
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Severity level"
          name="asd_severity_level"
          onChange={saveField}
          options={MEDICAL_SEVERITY_OPTIONS.map((value) => ({ label: value, value }))}
          placeholder="Select level"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Provider name"
          name="asd_diagnosis_provider_name"
          onBlur={saveField}
          placeholder="Enter provider name"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="City"
          name="asd_diagnosis_city"
          onBlur={saveField}
          placeholder="Enter city"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="State"
          name="asd_diagnosis_state"
          onChange={saveField}
          options={US_STATE_OPTIONS}
          placeholder="Select state"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormDateField
          disabled={disabled}
          formik={formik}
          format="YYYY"
          label="Year"
          name="asd_diagnosis_year"
          onChange={saveField}
          picker="year"
          placeholder="Diagnosis year"
          readOnly={readOnly}
          required
        />
      </Grid>
    </Grid>
  );
}
